import { DownloadIcon } from 'lucide-react';
import { useState } from 'react';

import { downloadPostsForScrapingJob } from '../../remote/download-posts-for-scraping-job';

import { RingSpinner } from '@/shared/components/loader/ring-spinner';
import { Button } from '@/shared/components/shadcn/button';

interface Props {
  scrapingJobId: string;
  disabled?: boolean;
}

export function PostDownloadButton({ scrapingJobId, disabled }: Props) {
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = async () => {
    if (isDownloading) return;

    setIsDownloading(true);
    try {
      await downloadPostsForScrapingJob(scrapingJobId);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <Button
      variant="default"
      size="icon"
      disabled={disabled || isDownloading}
      onClick={handleDownload}
    >
      {isDownloading ? <RingSpinner /> : <DownloadIcon />}
    </Button>
  );
}
